"use client";

import { LIVE_CITY_ID } from "@/app/(fevicol-inhomz)/_constants/cities";
import { colorPrimaryOnPrimaryContainer } from "@/app/(styles)/variables";
import { pushGtmEvent } from "@/lib/utils/gtmEventHandler";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import Image from "next/image";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
const PROFILE_HEADER_SCROLL_THRESHOLD = 280;
import ShareIconButton from "../[slug]/_components/ShareIconButton";
import cloudflareLoader from "@/lib/utils/cdn-cloudflare-loader";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
export default function DpHeader({
  digitalProfile,
  isLeadGenProfile
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [showHeaderProfile, setShowHeaderProfile] = useState(false);
  const track = useInhomzTrack();
  useEffect(() => {
    const onScroll = () => {
      setShowHeaderProfile(window.scrollY >= PROFILE_HEADER_SCROLL_THRESHOLD);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const handleBack = () => {
    // If user came from gallery, use browser history to go back
    if (searchParams.get("from") === "gallery") {
      router.back();
    } else {
      // Default: go to the contractor listing
      router.push(`/find-contractors/${LIVE_CITY_ID}`);
    }
    pushGtmEvent({
      event_name: "contractor_listing_page_action_taken",
      event_action: "back_button_clicked"
    });
  };
  useEffect(() => {
    pushGtmEvent({
      event_name: "contractor_profile_page_viewed",
      contractor_id: digitalProfile?.id,
      contractor_name: digitalProfile?.profileName,
      contractor_phone_number: digitalProfile?.phoneNumber,
      contractor_profile_id: digitalProfile?.profileId,
      project_photo_count: digitalProfile?.project_count
    });
    track(inhomzEvents.contractorProfile.VIEWED, profileEventProps(digitalProfile));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fromCarpenterLandingPage = typeof window !== "undefined" && sessionStorage.getItem("landingPage") === "carpenter";
  const handleBackButtonClick = () => {
    if (isLeadGenProfile && window.history.length > 1) {
      router.back();
      pushGtmEvent({
        event_name: "digital_profile_page_action_taken",
        event_action: "back_button_clicked"
      });
    } else if (fromCarpenterLandingPage) {
      router.push("/");
      pushGtmEvent({
        event_name: "digital_profile_page_action_taken__carpenter",
        event_action: "branding_logo_clicked"
      });
    } else {
      router.push("/");
      pushGtmEvent({
        event_name: "digital_profile_page_action_taken",
        event_action: "branding_logo_clicked"
      });
    }
  };
  return <div className={`w-full  sticky top-0 z-50 md:hidden block   `}>
      <div className="flex justify-between items-center  sticky top-0 z-50 max-w-[1120px] mx-auto bg-white h-[64px]">
        <div className="flex items-center ">
          {isLeadGenProfile ? <div className="w-[40px] h-[40px] pl-1">
              <IconButton onClick={handleBackButtonClick}>
                <ArrowBackIcon sx={{
              color: colorPrimaryOnPrimaryContainer
            }} />
              </IconButton>
            </div> : <>
              {!showHeaderProfile && <p className="m3-title-medium text-[--textSecondaryOnColorSecondary] pl-[16px] py-5 ">
                  Multiply Profile
                </p>}
            </>}

          {showHeaderProfile && <div className={`flex items-center gap-3 ${!isLeadGenProfile ? "pl-[16px]" : ""}`}>
              <div className="w-10 h-10 rounded-full overflow-hidden relative flex-shrink-0 border-[2px] border-[--colorDisabledOnColorDisabled]">
                {digitalProfile?.profilePicture ? <Image src={cloudflareLoader({
              src: digitalProfile?.profilePicture,
              width: 40,
              quality: 75
            })} className="rounded-full object-cover" alt="display picture" width={40} height={40} /> : <Image src={"/images/empty-dp-img.png"} className="rounded-full object-cover" fill sizes="40px" alt="display picture" quality={100} />}
              </div>
              <p className="m3-title-medium text-[--textPrimaryPrimary]">{digitalProfile?.profileName}</p>
            </div>}
        </div>
        <ShareIconButton profileName={digitalProfile?.profileName} trackShare />
      </div>
    </div>;
}